import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from '../stores/Hooks';
import { ModalTypeEnum } from '../stores/libraries/ModalLibrary';
import * as ModalComponent from '../components/ModalComponent/';

export const ModalMessage: React.FC<any> = observer(
	() =>
	{
		const { uiState } = useStores();
		const store = uiState.modal;

		if (store.ShowModal) document.body.classList.add('modal-show');
		else document.body.classList.remove('modal-show');

		function ShowMessageBody()
		{
			switch (store.ShowType)
			{
				case ModalTypeEnum.Component: return (<ModalComponent.ModalMessageShowComponent />);
				case ModalTypeEnum.Agreement: return (<ModalComponent.ModalMessageAgreement />);
				case ModalTypeEnum.DoSignature:
					uiState.stat.GetCertificateList();
					return (<ModalComponent.ModalMessageDoSignature />);
				case ModalTypeEnum.Error: return (<ModalComponent.ModalMessageError />);
				case ModalTypeEnum.LoadSignature: return (<ModalComponent.ModalMessageLoadSignature />);
				case ModalTypeEnum.Spinner: return (<ModalComponent.ModalMessageSpinner />);
				case ModalTypeEnum.StatementSignSelector: return (<ModalComponent.ModalMessageStatementSignSelector />);
				case ModalTypeEnum.StatementPreview: return (<ModalComponent.ModalMessageStatementPreview />);
				case ModalTypeEnum.ShowSignature: return (<ModalComponent.ModalMessageShowSignature />);
				case ModalTypeEnum.DeleteFormRequired: return (<ModalComponent.ModalMessageDeleteFormRequired />);
			}
		}

		return (
			<>
				{
					store.ShowModal &&
					<>
						<div className="modal-background"></div>
						<div className="modal d-flex align-items-center justify-content-center">
							<div className="modal-container">
								<div className="modal-header d-flex align-items-center">
									<div className="modal-header-text">{store.ModalCaption}</div>
									{
										store.ShowModalClose &&
										<button type="button" className="btn btn-icon icon-delete" onClick={() => { store.setShowModal(false); }}>
											<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
												<path d="M15.8334 5.34167L14.6584 4.16667L10.0001 8.82501L5.34175 4.16667L4.16675 5.34167L8.82508 10L4.16675 14.6583L5.34175 15.8333L10.0001 11.175L14.6584 15.8333L15.8334 14.6583L11.1751 10L15.8334 5.34167Z" />
											</svg>
										</button>
									}
								</div>
								{ShowMessageBody()}
							</div>
						</div>
					</>
				}
			</>
		)
	}
)
